export default __webpack_public_path__ + "static/media/Main Logo Multi Color-01.efedd39b.png";